import { Component, OnInit, ViewChild } from '@angular/core';
import { ZonaService } from 'src/app/services/zona.service';
import { Apollo } from 'apollo-angular';
import { FormBuilder, Validators } from '@angular/forms';
import { ClienteService } from 'src/app/services/cliente.service';
import { ConfirmacionService } from 'src/app/services/confirmacion.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { LoginService } from 'src/app/services/login.service';


@Component({
  selector: 'app-instalaciones-asignadas',
  templateUrl: './instalaciones-asignadas.component.html',
  styleUrls: ['./instalaciones-asignadas.component.scss']
})


export class InstalacionesAsignadasComponent implements OnInit {

  public userLogged: any

  public zonaSeleccionado: any;
  public zonas: any;
  public instalaciones: any[] = [];
  public allInstalaciones: any[] = [];
  public instalacionesId: any[] = [];
  public instalacionSeleccionado: any[] = [];
  public datosZona: any;
  public nameZone: any
  textoInput: any
  displayedColumns: string[] = ['instalaciones', 'eliminar'];
  dataSource: any


  @ViewChild(MatPaginator) paginator?: MatPaginator;

  constructor(
    private loginService: LoginService,
    private zonaService: ZonaService,
    private apollo: Apollo,
    private formBuilder: FormBuilder,
    private clienteService: ClienteService,
    private confirmacionService: ConfirmacionService) {
      this.userLogged = loginService.getUserData()
     }

  private buildForm() {

    this.datosZona = this.formBuilder.group({
      zona: ['', [Validators.required]],
      nameZone: [''],
      name: [''],
    });
  }

  ngOnInit(): void {
    this.buildForm();
    this.getZonasByCliente();
    this.getInstalacionesByCliente();

  }
  
  selectZona(e: any) {
    this.zonaSeleccionado = e;
    this.getInstalacionesByZona();
    this.getNameSelectedZone();
  }

  selectInstalacion(e: any) {
    const instalacion = e.value;
    if (e.selected) {
      this.instalacionSeleccionado.push(instalacion)
      this.instalacionSeleccionado = [...this.instalacionSeleccionado, ...this.instalacionesId];
    } else {
      this.instalacionSeleccionado = this.instalacionSeleccionado.filter((i: any) => i !== instalacion)
      this.instalacionSeleccionado = [...this.instalacionSeleccionado, ...this.instalacionesId];
    }
  }

  selectAllInstalaciones(e: any) {
    if (e) {
      const allInstalaciones = this.instalaciones;
      allInstalaciones.forEach((instalacion: any) => {
        this.instalacionSeleccionado.push(instalacion.id)
      });
    } else {
      this.instalacionSeleccionado = [];

    }
  }

  updateNameZona(e: any) {

    this.apollo.mutate({
      mutation: this.zonaService.updateZona(),
      variables: {
        "input": {
          "where": {
            "id": this.zonaSeleccionado
          },
          "data": {
            "nombre": e,

          }
        }
      }
    })
      .subscribe(({ data, errors }) => {
        console.log("EDITADO", data, errors)
        location.reload()
      }, (error) => {
        console.log(error)
      })
  }

  updateInstalacionesByZona() {

    this.apollo.mutate({
      mutation: this.zonaService.updateZona(),
      variables: {
        "input": {
          "where": {
            "id": this.zonaSeleccionado
          },
          "data": {
            "instalacions": this.instalacionSeleccionado

          }
        }
      }
    })
      .subscribe(({ data, errors }) => {
        console.log("EDITADO", data, errors)

      }, (error) => {
        console.log(error)
      })
  }

  deleteInstalacion(e: any) {
    this.instalacionesId = this.instalacionesId.filter((i: any) => i !== e.id)
    this.instalacionSeleccionado = this.instalacionesId
    this.handleClick();

  }

  handleClick() {
    const options = {
      text:"¿Está seguro que desea eliminar el registro?",
      cancelText: 'Cancelar',
      confirmText: 'Eliminar'
    };
    this.confirmacionService.open(options);

    this.confirmacionService.confirmed().subscribe(confirmed => {
      if (confirmed) {
        this.updateInstalacionesByZona();
       location.reload()
        
      }
    });
  }

  handleClickInstal() {
    const options = {
      text:"¿Está seguro que desea añadir las instalaciones seleccionadas al campo?",
      cancelText: 'Cancelar',
      confirmText: 'Confirmar'
    };
    this.confirmacionService.open(options);

    this.confirmacionService.confirmed().subscribe(confirmed => {
      if (confirmed) {
        this.updateInstalacionesByZona()
        location.reload()

      }
    });
  }


  getNameSelectedZone() {
    const nameZone = this.zonas.filter((zona: any) => this.zonaSeleccionado == zona.id);
    this.nameZone = nameZone[0];
  }

  getZonasByCliente() {
    this.apollo.watchQuery<any>({
      query: this.zonaService.getZonasByCliente(),
      variables: {
        "id": this.userLogged.cliente.id
      }
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        this.zonas = data.cliente.zonas
      });

  }

  getInstalacionesByZona() {
    this.apollo.watchQuery<any>({
      query: this.zonaService.getInstalacionesByZona(),
      variables: {
        "id": this.zonaSeleccionado
      }
    }).valueChanges.subscribe(({ data, loading, error }) => {

      const instalacionId: any = [];

      data.zona.instalacions.forEach((install: any) => {
        instalacionId.push(install.id)
      });


      this.instalaciones = data.zona.instalacions;
      this.setDataTableOptions()

      const filterInstall: any = [];
      this.allInstalaciones.forEach(i => {
        let existe = false;
        this.instalaciones.forEach(j => {
          i.id == j.id && (existe = true);
        });
        !existe && filterInstall.push(i);
      });

      this.allInstalaciones = filterInstall;

      this.instalaciones.forEach((allId: any) => {
        this.instalacionesId.push(allId.id)
      });
    })
  }

  setDataTableOptions() {
    this.dataSource = new MatTableDataSource(this.instalaciones)
    this.dataSource.paginator = this.paginator;
  }

  getInstalacionesByCliente() {
    this.apollo.watchQuery<any>({
      query: this.clienteService.getInstalacionesByCliente(),
      variables: {
        "id": this.userLogged.cliente.id
      }
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        this.allInstalaciones = data.cliente.instalaciones;
      });
  }

}
